import React from 'react';
import { transitions, positions, Provider as AlertProvider, useAlert } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import { setAlertRef } from 'services/alerts';

// Custom alert styles to ensure alerts display above other elements like chat widgets
const alertStyle = {
  backgroundColor: '#151515',
  color: 'white',
  padding: '10px',
  borderRadius: '3px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
  width: '300px',
  boxSizing: 'border-box',
  zIndex: 99999, // Very high z-index to ensure it appears above everything
  position: 'relative' // Ensure z-index works
};

const buttonStyle = {
  marginLeft: '20px',
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  color: '#f2f2f2'
};

// Custom icon styles
const errorIcon = {
  color: '#FF0040',
  marginRight: '10px'
};

const infoIcon = {
  color: '#2E9AFE',
  marginRight: '10px'
};

const successIcon = {
  color: '#00C12B',
  marginRight: '10px'
};

// Custom AlertTemplate component
const CustomAlertTemplate = ({ message, options, style, close }) => (
  <div style={{ ...alertStyle, ...style }}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {options.type === 'info' && <span style={infoIcon}>ℹ️</span>}
      {options.type === 'success' && <span style={successIcon}>✅</span>}
      {options.type === 'error' && <span style={errorIcon}>❌</span>}
      <span style={{ wordBreak: 'break-word' }}>{message}</span>
    </div>
    <button onClick={close} style={buttonStyle}>
      ✕
    </button>
  </div>
);

const options = {
    position: positions.BOTTOM_RIGHT,
    timeout: 5000,
    transition: transitions.FADE,
    containerStyle: {
      zIndex: 99999 // Ensure the container also has a high z-index
    }
};  

let alertRef = null;

const Inner = () => {
    alertRef = useAlert();
    setAlertRef(alertRef);
    return <div />;
};

export default props => {
    return (
        <AlertProvider template={CustomAlertTemplate} {...options}>
            <Inner />
            {props.children}
        </AlertProvider>
    );
};
